@use 'styles/colors' as *;

.arrowRightIcon {
    aspect-ratio: 1;
    color: var(--arrow-right-icon-color);
    height: 100%;
    width: 100%;

    path {
        stroke: var(--arrow-right-icon-stroke-color);
    }
}
